<template>
  <div class="">
    <div class="p-2 cursor-pointer" @click="isOpen = !isOpen">
      <slot name="title" :isOpen="isOpen">Accordion Title</slot>
    </div>
    <transition name="fade">
      <div class="p-2" v-show="isOpen">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'GdAccordion',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: this.active
    };
  }
};
</script>
